import { BaseAPI } from "../../BaseAPI";
import { CtvBasvuruRequest } from './CtvBasvuruave';
import * as environment from '../../../config/environment';

class ProjeOneriAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "ProjeOneriSave";
    super(baseUrl);
  }


  saveProjeOneriSave(request: ProjeOneriSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new ProjeOneriAPI();

class ProjeOneriSaveRequest {
    basvuruTuruId: number=-2;
    kullaniciKodu?: number;
    tcKimlikNo?: number;
    cepTelefonu?: number;
    mahalleKodu: number;
    caddeSokakKodu: number;
    projeKategoriKodu: number;
    projeAdi?: string;
    projeFayda: string;
    projeIcerik: string;
    medyaYayinEH: string;

    constructor(
        mahalleKodu: number,
        caddeSokakKodu: number,
        projeKategoriKodu: number,
        projeFayda: string,
        projeIcerik: string,
        medyaYayinEH: string,
        kullaniciKodu?: number,
        tcKimlikNo?: number,
        cepTelefonu?: number,
        projeAdi?: string
    ) {
        this.kullaniciKodu = kullaniciKodu;
        this.tcKimlikNo = tcKimlikNo;
        this.cepTelefonu = cepTelefonu;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.projeKategoriKodu = projeKategoriKodu;
        this.projeAdi = projeAdi;
        this.projeFayda = projeFayda;
        this.projeIcerik = projeIcerik;
        this.medyaYayinEH = medyaYayinEH;
    }
}
export { ProjeOneriSaveRequest };
